import {EDIT_MONITOR_EVENT} from "../../../constants/MonitorConstants";
import {EventStoredObject, MarketCapObject, MoneyLineObject} from "../../../@types/response";
import {GeneralAction} from "../../../@types/actions";

export const UpdateEventAction = (event: EventStoredObject, marketsCap: MarketCapObject, moneyLines: MoneyLineObject): GeneralAction<any> => ({
    type: EDIT_MONITOR_EVENT,
    payload: {event, marketsCap, moneyLines}
});
